export function includes(search: RegExp, ...target: string[]) {
  return target.filter(v => v).some(v => v.search(search) != -1)
}

export function escapeTag(s: string): string {
  if (!s) return ''
  s = s.replace(/\\n/g, '<br>')
  if (!s.includes('<')) return s
  if (import.meta.client) {
    let div = document.createElement('div')
    div.innerHTML = s
    return div.textContent || div.innerText
  } else {
    return s
  }
}

export function isEmptyDelta(d: Delta) {
  return (
    d == null ||
    d.ops == null ||
    d.ops.length == 0 ||
    d.ops.every(
      op =>
        op.insert == null || op.insert === '' || /^[\\n\s]+$/.test(op.insert),
    )
  )
}

export function isEmptyLangDelta(d: LangDelta): boolean {
  return d == null || (isEmptyDelta(d.ja) && isEmptyDelta(d.en))
}

export function createEmptyDelta(): Delta {
  return { ops: [{ insert: '\n' }] }
}

export function zenkaku2Hankaku(str) {
  return str.replace(/[０-９]/g, function (s) {
    return String.fromCharCode(s.charCodeAt(0) - 0xfee0)
  })
}

export function abb(str: string, len: number): string {
  if (!str) return ''
  if (str.length < len) return str
  return str.substring(0, len) + '...'
}
